import React from 'react';
import { useHistory } from 'react-router-dom';

import { IconButton } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { styleComponentStudent, styleToolBar } from '../../Tool/Style';

const BackBtnIcon = ({ text = "" }) => {

   const history = useHistory();

   return (
      <div style={{...styleComponentStudent.DivConteinerButtonBack,
         padding: "10px 0px 0px",
         marginTop: "12px"
      }}>
         <IconButton 
            onClick={() => history.goBack() }
            style={styleToolBar.IconButton}
            title={text}
         >
            <KeyboardArrowLeftIcon 
               fontSize="large"
               style={styleToolBar.Icon}
            />
         </IconButton>
      </div>
   )
}

export default BackBtnIcon;